import { Injectable } from '@angular/core';

export type HapticsStrength = 'light' | 'medium' | 'heavy' | 'success';

const DURATIONS_MS: Readonly<Record<HapticsStrength, number | readonly number[]>> = {
  light: 10,
  medium: 20,
  heavy: 35,
  success: [10, 40, 10]
};

@Injectable({ providedIn: 'root' })
export class HapticsService {
  impact(strength: HapticsStrength): void {
    const pattern: number | readonly number[] = DURATIONS_MS[strength];
    this.vibrate(pattern);
  }

  private vibrate(pattern: number | readonly number[]): void {
    const nav: Navigator | undefined = typeof navigator === 'undefined' ? undefined : navigator;
    if (nav === undefined || typeof nav.vibrate !== 'function') {
      return;
    }
    try {
      const arg: number | number[] = typeof pattern === 'number' ? pattern : [...pattern];
      nav.vibrate(arg);
    } catch {
      // Vibration unsupported / permission denied - silently no-op.
    }
  }
}
